import React from "react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { IconButton, Tooltip } from "@mui/material";
import { MANUAL_URL } from "@/configs/constants";

export const ResearchRequestManualLink: React.FC = () => (
  <Tooltip title="操作ガイドを開く" placement="top">
    <IconButton
      aria-label="マニュアルを開く"
      size="small"
      onClick={() => {
        window.open(MANUAL_URL, "_blank", "noopener,noreferrer");
      }}
      sx={{
        "&:hover": {
          backgroundColor: "rgba(59, 130, 246, 0.1)",
          transform: "scale(1.1)",
        },
      }}
    >
      <OpenInNewIcon
        sx={{
          fontSize: { xs: "18px", sm: "20px" },
          color: "#3b82f6",
        }}
      />
    </IconButton>
  </Tooltip>
);
